import { SET_LOADER } from './actionTypes';

export function setLoader(payload) {
  return {
    type: SET_LOADER,
    payload,
  };
}
